import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { forgotPassword } from '../utils/paymentApi';
import { showError, showSuccess } from '../utils/snackbar';
import './Auth.css';

// Step 1: request password-reset OTP by email
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false,
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      await forgotPassword(this.state.email.trim());
      showSuccess('If an account exists, a reset code was sent.');
      const email = encodeURIComponent(this.state.email.trim());
      window.location.href = `/reset-password?email=${email}`;
    } catch (e) {
      showError(_.get(e, 'message', 'Could not start password reset'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, loading } = this.state;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Forgot password</h1>
          <p className="auth-sub">
            Enter your account email. We will send a one-time code to reset your password.
          </p>
          <form onSubmit={this.handleSubmit}>
            <label htmlFor="fp-email">Email</label>
            <input
              id="fp-email"
              type="email"
              value={email}
              onChange={this.handleChange('email')}
              required
            />
            <button type="submit" className="auth-cta" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset code'}
            </button>
          </form>
          <p className="auth-footer">
            Remembered it? <Link to="/login">Back to log in</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
